
import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import httpClient from "@/store/httpClient";
import { UserDto } from "@/dtos/userDto";

interface UserOption {
	text: string;
	value: string;
}

@Component
export default class CustomerLogs extends Vue {
	@Prop({ required: true })
	private users!: UserDto[];

	private logs: any[] = [];
	private loading: boolean = false;
	private hasMore: boolean = true;
	private pageSize: number = 200;
	private selectedUsers: UserOption[] = [];

	private headers = [
		{ text: "Zeit", value: "timeStamp", sortable: false },
		{ text: "Level", value: "level", sortable: false },
		{ text: "System", value: "system", sortable: false },
		{ text: "Benutzer", value: "userId", sortable: false },
		{ text: "Meldung", value: "message", sortable: false },
	];

	private mounted() {
		const options = this.userOptions;
		if (options.length > 0) {
			this.selectedUsers = [options[0]];
		}
		this.loadLogs(true);
	}

	private get userOptions(): UserOption[] {
		return (this.users || [])
			.filter((u) => !!u.userId)
			.map((u) => ({ text: u.eMail || u.userId, value: u.userId }));
	}

	private get userIdsParam(): string {
		const ids = this.userOptions.map((o) => o.value);
		return ids.join(",");
	}

	private get filteredLogs() {
		if (!this.selectedUsers || this.selectedUsers.length === 0) {
			return this.logs;
		}
		const selectedIds = new Set(this.selectedUsers.map((u) => u.value));
		return this.logs.filter((l) => l.userId && selectedIds.has(l.userId));
	}

	private userLabel(userId: string): string {
		if (!userId) return "";
		const match = this.userOptions.find((o) => o.value === userId);
		return match ? match.text : userId;
	}

	private async loadLogs(reset: boolean) {
		if (this.loading) return;
		if (!this.userIdsParam) {
			this.logs = [];
			this.hasMore = false;
			return;
		}
		try {
			this.loading = true;
			if (reset) {
				this.logs = [];
				this.hasMore = true;
			}
			const skip = this.logs.length;
			const startString = moment().format("YYYY-MM-DDTHH:mm:ss");
			const response = await httpClient().get(
				`Log/GetLogs?skip=${skip}&take=${this.pageSize}` +
					`&start=${startString}` +
					`&suche=&system=&level=` +
					`&userId=${encodeURIComponent(this.userIdsParam)}`
			);
			const data = response.data as any[];
			if (!data || data.length < this.pageSize) {
				this.hasMore = false;
			}
			if (data && data.length > 0) {
				this.logs.push(...data);
			}
		} catch {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Laden der Logs.");
		} finally {
			this.loading = false;
		}
	}

	private loadMore() {
		this.loadLogs(false);
	}

	private truncate(value: string, length: number) {
		if (!value) return "";
		return value.length > length ? value.substring(0, length) + "…" : value;
	}

	private formattedMessage(message: string) {
		const textArea = document.createElement("textarea");
		textArea.innerHTML = message;
		return textArea.innerHTML.replace(/(?:\r\n|\r|\n)/g, "<br>");
	}
}
